import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const LegacyIntegrationsRedirect: React.FC = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  params.set("view", "Settings");
  params.set("tab", "integrations");

  return <Navigate to={`/?${params.toString()}`} replace />;
};

export default LegacyIntegrationsRedirect;
